import React, { useState, useEffect } from 'react';
import { Container, Jumbotron, Row, Col, Spinner } from 'react-bootstrap';
import { NotesBooksCard } from '../Components/NotesBooksCard';
import Axios from 'axios';
import { useParams } from 'react-router';
export const NotesBooks = () => {
  const [content, setContent] = useState([]);
  const { role } = useParams();
  //   let items = [
  //     {
  //       name: 'Python Cheats Sheet',
  //       videoUrl: '',
  //       attachedDocument: 'https://www.youtube.com/watch?v=IVG5Rxxpj_E',
  //       sys: {
  //         publishedAt: '2020-12-17T13:33:30.651Z',
  //       },
  //     },
  //     {
  //       name: 'Python Begninner',
  //       videoUrl: '',
  //       attachedDocument: 'https://www.youtube.com/watch?v=IVG5Rxxpj_E',
  //       sys: {
  //         publishedAt: '2020-12-17T13:32:51.275Z',
  //       },
  //     },
  //   ];
  const getContent = () => {
    try {
      Axios({
        url: '/.netlify/functions/fetchContent',
        params: {
          subject: 'Notes and Books',
          cr: role,
        },
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(localStorage.getItem('tokens')).access.token,
          credentials: 'include',
        },
      })
        .then((response) => {
          setContent(response.data.items);
        })
        .catch(console.error);
    } catch {
      window.location.href = '/';
    }
  };
  useEffect(getContent, [role]);
  return (
    <Container className='py-4'>
      <Jumbotron className='bg-custom-3 rounded' fluid style={{ padding: 20 }}>
        <Container>
          <h1 className='text-center'>Notes And Books</h1>
          <p className='text-center'>
            Here you can fill all the uploaded notes and books.
          </p>
        </Container>
      </Jumbotron>
      <Row className='d-flex justify-content-center '>
        {content ? (
          content.map((elem, index) => {
            return (
              <Col className='m-2 mx-4' md={3}>
                <NotesBooksCard
                  name={elem.name}
                  attachedDocument={elem.attachedDocument}
                  sys={elem.sys}
                />
              </Col>
            );
          })
        ) : (
          <Spinner className='text-center' animation='border'></Spinner>
        )}
      </Row>
    </Container>
  );
};
